import { LISCaseList } from "pwapi";

import AccessionNumber from "ui/components/AccessionNumber";
import CasePriority from "ui/components/CasePriority";

const CaseReadyItem = ({ readyCase }: { readyCase: LISCaseList }) => {
  return (
    <article className="Object">
      <p className="Label">
        <CasePriority priorityCase={readyCase} />
        <AccessionNumber accession={readyCase.accession} />
      </p>
      <p className="Label--patient">
        {readyCase.patient?.last_name}, {readyCase.patient?.first_name}
      </p>
    </article>
  );
};

export default CaseReadyItem;
